import React from 'react';
export function Footer() {
  return <footer className="bg-[#0a0a0a] border-t border-zinc-900 py-12 px-4" data-id="element-68">
      <div className="max-w-6xl mx-auto flex flex-col items-center text-center" data-id="element-69">
        <div className="mb-6" data-id="element-70">
          <span className="text-2xl font-black text-white tracking-tighter" data-id="element-71">
            COCINA<span className="text-emerald-500" data-id="element-72">VEGGIE</span>
          </span>
        </div>

        <p className="text-zinc-500 text-sm mb-6" data-id="element-73">
          © 2025 Cocina Veggie — Todos los derechos reservados
        </p>

        <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm text-zinc-400 mb-8" data-id="element-74">
          <a href="#" className="hover:text-emerald-400 transition-colors" data-id="element-75">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-emerald-400 transition-colors" data-id="element-76">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-emerald-400 transition-colors" data-id="element-77">
            Contacto
          </a>
        </div>

        <p className="text-xs text-zinc-600 max-w-2xl leading-relaxed" data-id="element-78">
          Este producto es un bien digital descargable. Al completar la compra
          aceptás los términos y condiciones. Los resultados pueden variar según
          cada persona.
        </p>
      </div>
    </footer>;
}